<div cdkOverlayOrigin>
  <div class="fm-search-light-fab" [class.fm-search-light-fab--active]="isActive">
    <button
      mat-icon-button
      #inputIcon
      class="fm-search-light-fab__open-button btn fab fab-secondary"
      type="button"
      a7s-id="live-map-search-light-fab-open"
      i18n-aria-label="@@S_ROUTIST_SEARCH"
      aria-label="search"
      [matTooltip]="tooltipMessage"
      (click)="onOpen()"
    >
      <mat-icon svgIcon="ds-ic-search" *ngIf="!isLoading" i18n-aria-label="@@S_ROUTIST_SEARCH" aria-label="Search"></mat-icon>
      <mat-spinner *ngIf="isLoading" [diameter]="16" color="accent"></mat-spinner>
    </button>
    <div class="fm-search-light-fab__input-container" #inputContainer>
      <fm-search-light-input
        class="fm-search-light-fab__input-comp"
        classes="fm-search-light-fab__input"
        elementId="txt-search-light-fab"
        [(ngModel)]="searchText"
        [placeholder]="placeholder"
        [triggerable]="triggerable"
        [isActive]="isActive"
        [isLoading]="isLoading"
        (closed)="onClose()"
      ></fm-search-light-input>

      <button
        mat-icon-button
        *ngIf="searchText.length > 0; else emptySpace"
        class="fm-search-light-fab__close-button fab fab-secondary"
        type="button"
        a7s-id="live-map-search-light-fab-close"
        i18n-aria-label="@@S_CLOSE_SEARCH_BUTTON"
        aria-label="Close Search"
        (click)="onClear($event)"
      >
        <mat-icon svgIcon="ds-ic-close" i18n-aria-label="@@S_CLOSE_BUTTON" aria-label="Close"></mat-icon>
      </button>
    </div>
  </div>
</div>

<ng-template #emptySpace>
  <div class="fab fab-alt" (click)="$event.stopPropagation()"></div>
</ng-template>
